export default "__VITE_ASSET__CIVRB3vc__"